import mdcDrawer from './mdc-drawer.vue'
export type DrawerType = 'modal'|'permanent' | 'dismissible'
export const mdcDrawerComponents ={
  mdcDrawer,
}

